// extracted by mini-css-extract-plugin
export default {"error":"Input_error__5TKlg"};